import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { SegmentationQuestion } from 'frontend/types/segmentation';

interface SegmentationQuestionState {
  question: SegmentationQuestion | null;
}

const segmentationQuestion: Module<SegmentationQuestionState, RootState> = {
  namespaced: true,
  state: () => ({
    question: null,
  }),
  getters: {
    segmentationQuestion: state => state.question,
  },
  mutations: {
    setValue(state: SegmentationQuestionState, value: SegmentationQuestion): void {
      state.question = value;
    },
  },
  actions: {},
};

export default segmentationQuestion;
